const LS_PREFIX = 'ATLASSIAN-STUDIO-';
export const OVERRIDES_KEY: 'ATLASSIAN-STUDIO-local-overrides' = `${LS_PREFIX}local-overrides`;
